export default "__VITE_ASSET__DcCPkGvz__"